/* version: 5.0.0 */

import { Lazyloader } from "./lazyloader";
import { getUrlParts } from '@Utils/get-url-parts';

const RESIZE_METHODS = ['fit', 'longer', 'shorter', 'width', 'height'];
const BREAKPOINTS = {medium: 1024, small: 480};
const FILE_EXT_REGEX = /(?:\.([^.]+))?$/;
  
const config = {
    selector: '.lazyload',
    buildDisableClass: 'js-iao-off',
    urlBuiltClass: 'js-iao-url-built',
    allowedExtensions: ['webp', 'jpg', 'png'],
    observerOptions: {rootMargin: '100px'},
    onUrlBuilt: $.noop
};
let observer = null;
let hasIntersectionObserver = null;
let hasWebp = null;

function urlBuildIsOn() {
    /* klucz 'use_image_auto_optimizer' w konfiguracji jest nieco mylący na ten moment (jeśli false to i tak używamy IAO do lazyloada) */
    return ICUBE_CONFIG.use_image_auto_optimizer;
}

function getDomain() {
    return ICUBE_CONFIG.static_domain;
}

function getResizeMethod($target) {
    let resizeMethod = 'width';
    const data = $target.data('resize');
    
    if (data && RESIZE_METHODS.indexOf(data) > -1) {
        resizeMethod = data;
    }
    
    return '-' + resizeMethod;
}

function getElWidth($target, dataKey) {
    if (dataKey === 'bg') {
        return $target.width();
    } else {
        return $target.parent().width();
    }
}

function getSizesParam($target, dataKey) {
    const elWidth = getElWidth($target, dataKey);
    const resizeMethod = $target.data('resize') || '';
    let matchedKey = '';
    let width = '';
    let height = '';

    $.each(BREAKPOINTS, function(key, breakpoint) {  
        if (elWidth > breakpoint) {
            return false;
        }
        
        if ((elWidth <= breakpoint) && (matchedKey ? (breakpoint < BREAKPOINTS[matchedKey]) : true)) {
            matchedKey = key;
        }
    });
    
    if (matchedKey) {
        if (resizeMethod !== 'height') {
            width += $target.data(matchedKey + '-width') || BREAKPOINTS[matchedKey];
        }
            
        height += $target.data(matchedKey + '-height') || '';         
    } else {
        width += $target.data('width') || '';
        height += $target.data('height') || '';
    }          
    
    return (width || height ? '-' + width + 'x' + height  : '');
}

function hasValidDomain(imageOrigin) {
    return (imageOrigin + '/').indexOf(getDomain()) === 0;
}

function hasIntersectionObserverSupport() {
    if (hasIntersectionObserver === null) {
        /* kopia warunku z https://github.com/w3c/IntersectionObserver/blob/master/polyfill/intersection-observer.js */
        if ('IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window &&
            'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

            // Minimal polyfill for Edge 15's lack of `isIntersecting`
            // See: https://github.com/w3c/IntersectionObserver/issues/211
            if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
                Object.defineProperty(window.IntersectionObserverEntry.prototype,
                    'isIntersecting', {
                    get: function () {
                        return this.intersectionRatio > 0;
                    }
                });
            }

            hasIntersectionObserver = true;
        }

        hasIntersectionObserver = false;
    }

    return hasIntersectionObserver;
}

function hasWebpSupport() {
    if (hasWebp === null) {
        hasWebp = ICube.data.get('hasWebp');
    }

    return hasWebp;
}

function getObserver() {
    if (!observer) {
        observer = new IntersectionObserver(function(entries) {
            entries.map(function(entry) {
                if (entry.isIntersecting) {
                    const $target = $(entry.target);
                  
                    ImageAutoOptimizer.buildUrl($target);
                    Lazyloader.load($target);
                    observer.unobserve(entry.target);
                }
            });
        }, config.observerOptions);
    }

    return observer;
}

export const ImageAutoOptimizer = {
    observe: function($targets) {
        const module = this;
        
        if (typeof $targets === 'string') {
            $targets = $($targets);
        }

        if ($targets.length) {           
            if (hasIntersectionObserverSupport()) {             
                const observer = getObserver();
        
                $targets.each(function() {
                    observer.observe(this);  
                });
            } else {
                $targets.each(function() {
                    module.buildUrl($(this));
                });
                Lazyloader.init();
            }         
        }
    },
    observeBox: function($box) {
        this.observe($box.find(config.selector));
    },
    setConfig: function(newConfig) {
        if (newConfig) {
            $.extend(true, config, newConfig);
        }    
    },
    init: function(initialConfig) {
        this.setConfig(initialConfig);
        this.observe($(config.selector)); 
    },
    buildUrl: function($target) {
        if (urlBuildIsOn() && !$target.hasClass(config.buildDisableClass) && !$target.hasClass(config.urlBuiltClass)) {
            const dataKey = $target.data('bg') ? 'bg' : ($target.data('src') ? 'src' : false);
            let imgExt = '';
            let newImgSrc = '';
            let sizesParam = '';
            let resizeMethod = '';
            let urlParts;

            if (!dataKey) {
                console.warn('ImageAutoOptimizer: unsupported data key');
                return;
            }

            urlParts = getUrlParts($target.data(dataKey));

            if (hasValidDomain(urlParts.origin)) {
                imgExt = FILE_EXT_REGEX.exec(urlParts.pathname)[1];

                if (imgExt && (config.allowedExtensions.indexOf(imgExt) > -1)) {
                    const hasWebp = hasWebpSupport();

                    if (!hasWebp && imgExt === 'webp') {
                        return;
                    }
                    sizesParam = getSizesParam($target, dataKey);

                    if (sizesParam) {
                        resizeMethod = getResizeMethod($target);
                    }

                    newImgSrc = urlParts.origin
                            + '/imgv-' + (hasWebp ? 'webp' : ($target.data('format') || imgExt))  
                            + sizesParam
                            + ($target.data('quality') ? '-q' + $target.data('quality') : '')
                            + resizeMethod
                            + urlParts.pathname;

                    $target.attr('data-' + dataKey, newImgSrc);
                    $target.addClass(config.urlBuiltClass);
                    config.onUrlBuilt($target);
                }
            }
        }
    },
    buildUrls: function($parent) {
        const module = this;
        const $targets = $parent.find(config.selector);

        if ($targets.length) {
            $targets.each(function() {
                module.buildUrl($(this));
            });
        }
    }
}